var scope_0 = require('/Users/samuelsson/Projects/personal/samuelsson-homepage/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1f65fe9ae8156b48a111d2751d7e31de.js').default;
var scope_1 = require('/Users/samuelsson/Projects/personal/samuelsson-homepage/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/484f0b7e1f8b3bf400e04a131ccd323a.js').default;
var scope_2 = require('/Users/samuelsson/Projects/personal/samuelsson-homepage/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/78bac0d2fbf1a8cc01f50a84c85c4b61.js').default;
var scope_3 = require('/Users/samuelsson/Projects/personal/samuelsson-homepage/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    